'use strict';

import { schema } from './schema.fn';

schema.$inject = ['fieldDefinitionService', 'htmlService', 'dateUtils', '$window', 'configuration', '$translate'];
angular.module('kerp-forms.forms').factory('FCR_SCHEMA', schema);
